



































import {Component, Vue} from "vue-property-decorator";
import {namespace} from "vuex-class";
import TextAreaInput from "@/views/components/FormInputs/TextAreaInput.vue";
import {CROSS_TOWN_ROUTES} from "@/constants/routes";
import DroppoButton from "@/views/components/DroppoButton.vue";
import DropupLayout from "@/views/Dropups/DropupLayout.vue";
import OrderButtonPhone from "@/views/components/Orders/OrderButtonPhone.vue";
import OrderButtonLocationSize from "@/views/components/Orders/OrderButtonLocationSize.vue";
import ReceiverPhone from "@/views/Dropups/views/ReceiverPhone.vue";
import CellChooserWrapper from "@/views/Dropups/views/CellChooserWrapper.vue";
import SelectHub from "@/views/Dropups/views/SelectHub.vue";
import {ANALYTIC_ROUTING} from "@/services/Analytics";

const shipmentStore = namespace("shipment");
const hubsStore = namespace("hubs");

@Component({
  name: 'CrosstownForm',
  components: {
    DropupLayout,
    ReceiverPhone,
    DroppoButton,
    CellChooserWrapper,
    SelectHub,
    TextAreaInput,
    OrderButtonPhone,
    OrderButtonLocationSize,
  },
})
export default class CrosstownForm extends Vue {
  @shipmentStore.Getter("getNote")
  private getNote!: string;

  @shipmentStore.Action("setNotes")
  private setNotes!: (notes: string) => void;

  private notes: string = "";
  private isPhoneValid: boolean = false;
  private isAddressSizeValid: boolean = false;

  get formHasNeededData(): boolean {
    return this.isPhoneValid && this.isAddressSizeValid;
  }

  private created() {
    ANALYTIC_ROUTING.enterCrosstown(this.$gtag);
    this.$uiBus.emit("hubOrderTitle", this.$t('crossTownDelivery.title'));
    // this.checkDropup();
    this.notes = this.getNote;
  }

  private next() {
    if (this.formHasNeededData) {
      this.setNotes(this.notes);
      this.$router.push({name: CROSS_TOWN_ROUTES.SUMMARY});
    }
  }

  private setIsPhoneValid(isPhoneValid: boolean) {
    this.isPhoneValid = isPhoneValid;
  }

  private setIsAddressSizeValid(isAddressSizeValid: boolean) {
    this.isAddressSizeValid = isAddressSizeValid;
  }
 }
